import React from "react";
import { withRouter } from "react-router-dom";
import "./NeedsAttention.css";

const NeedsAttention = ({ 
    draftBookings = 0,
    pendingResponses = 0,
    negotiateBookings = 0,
    cancelledBookings = 0,
    declinedBookings = 0,
    history 
}) => {
    const allCategories = [
        {
            key: "draft",
            count: draftBookings,
            icon: "fa fa-file-alt",
            color: "#64B5F7",
            bgColor: "rgba(100, 181, 247, 0.15)",
            title: "Draft Bookings",
            subtitle: count => `${count} booking${count !== 1 ? 's' : ''} need${count === 1 ? 's' : ''} completing`,
            action: () => history.push("/agent/gig/draft")
        },
        {
            key: "negotiate",
            count: negotiateBookings,
            icon: "fa fa-comments",
            color: "#FE0D9D",
            bgColor: "rgba(254, 13, 157, 0.12)",
            title: "Negotiate",
            subtitle: count => `${count} booking${count !== 1 ? 's' : ''} in negotiation`,
            action: () => history.push("/agent/gig/request")
        },
        {
            key: "pending",
            count: pendingResponses,
            icon: "fa fa-clock",
            color: "#1665C0",
            bgColor: "rgba(22, 101, 192, 0.12)",
            title: "Pending Requests",
            subtitle: count => `${count} gig${count !== 1 ? 's' : ''} awaiting response`,
            action: () => history.push("/agent/gig/request")
        },
        {
            key: "declined",
            count: declinedBookings,
            icon: "fa fa-times-circle",
            color: "#D62727",
            bgColor: "rgba(214, 39, 39, 0.12)",
            title: "Declined Requests",
            subtitle: count => `${count} gig${count !== 1 ? 's' : ''} declined`,
            action: () => history.push("/agent/gig/request")
        },
        {
            key: "cancelled",
            count: cancelledBookings,
            icon: "fa fa-ban",
            color: "#000000",
            bgColor: "rgba(0, 0, 0, 0.08)",
            title: "Cancelled by Act",
            subtitle: count => `${count} booking${count !== 1 ? 's' : ''} cancelled by act`,
            action: () => history.push("/agent/gig/cancelled")
        }
    ];
    
    const activeItems = allCategories.filter(item => item.count > 0);
    const totalCount = activeItems.reduce((sum, item) => sum + item.count, 0);

    return (
        <div className="needs-attention-card">
            <div className="needs-attention-header">
                <h3 className="needs-attention-title">
                    Needs Attention
                    {totalCount > 0 && (
                        <span className="needs-attention-badge">{totalCount}</span>
                    )}
                </h3>
            </div>
            <div className="needs-attention-body">
                {activeItems.length === 0 ? (
                    <div className="needs-attention-empty">
                        <i className="fa fa-check-circle"></i>
                        <p>All caught up! No items need attention.</p>
                    </div>
                ) : (
                    activeItems.map((item) => (
                        <div 
                            key={item.key} 
                            className="attention-item"
                        >
                            <div 
                                className="attention-icon" 
                                style={{ background: item.bgColor, color: item.color }}
                            >
                                <i className={item.icon}></i>
                            </div>
                            <div className="attention-content">
                                <div className="attention-title">{item.title}</div>
                                <div className="attention-desc">{item.subtitle(item.count)}</div>
                            </div>
                            <button 
                                className="attention-view-btn"
                                onClick={item.action}
                            >
                                View
                            </button>
                        </div>
                    ))
                )}
            </div>
        </div>
    );
};

export default withRouter(NeedsAttention);
